import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PaginatorCustomComponent } from './paginator-custom.component';
import { PaginatorCustomService } from './paginator-custom.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [PaginatorCustomComponent],
  exports: [PaginatorCustomComponent],
  providers: [PaginatorCustomService]
})
export class PaginatorCustomModule { }



// WEBPACK FOOTER //
// ./src/app/utils/paginator-custom/paginator-custom.module.ts